var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransactionComment(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.392H7.337c-1.05 0-1.902.851-1.902 1.902v7.608c0 1.05.851 1.903 1.902 1.903h2.853l3.804 3.804v-3.804h4.756c1.05 0 1.902-.852 1.902-1.902v-7.61c0-1.05-.852-1.901-1.902-1.901zm.95 9.51a.952.952 0 01-.95.952h-5.707v2.46l-2.46-2.46H7.338a.952.952 0 01-.951-.951v-7.61c0-.524.426-.95.95-.95H18.75c.524 0 .95.426.95.95v7.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.695 10.74h8.696V9.651H8.695v1.087zM8.695 12.913h8.696v-1.087H8.695v1.087z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionComment);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/IconTransactionComment.95189545.svg";
export { MemoForwardRef as ReactComponent };